import React, { CSSProperties } from "react";

import { DotLoader } from "react-spinners";

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "grey",
  color: "grey",
};

type LoaderPropTypes = {
  loader: boolean;
};

function Loader(props: LoaderPropTypes) {
  const { loader } = props;
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <DotLoader
        loading={loader}
        cssOverride={override}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}

export default Loader;
